import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-event-details-step',
  templateUrl: './event-details-step.component.html',
  styleUrls: ['../event-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EventDetailsStepComponent {
  eventForm: InputSignal<UntypedFormGroup> = input.required();
  isEventLocked: InputSignal<boolean> = input.required();

  get name() {
    return this.eventForm().get('name');
  }
  get clientName() {
    return this.eventForm().get('clientName');
  }
  get streetAddress() {
    return this.eventForm().get('streetAddress');
  }
  get city() {
    return this.eventForm().get('city');
  }
  get state() {
    return this.eventForm().get('state');
  }
  get startTime() {
    return this.eventForm().get('startTime');
  }
  get endTime() {
    return this.eventForm().get('endTime');
  }

  isStartDateInPast = (): boolean => {
    const startTime = this.eventForm()?.get('startTime')?.value;
    if (!startTime) return false;
    return new Date(startTime).getTime() <= new Date().getTime();
  };
}
